import { useCallback, useContext, useState } from 'react'
import { useComun } from '../../../Hooks/useComun';
import { EnumAreaNegocio, EnumModuloDesc, EnumTipoArchivos } from '../../../Utils/Enumeradores/ComunEnum';
import { ObtenerEstadoAutorizacion } from '../Services/ObtenerEstadoAutorizacion';
import { ObtenerIndicadoresPorAN } from '../Services/ObtenerIndicadoresPorAN';


export function useInformesConservacion() { 

    const [indicadorTotal, setIndicadorTotal] = useState([]);
    const [listaEstadoAutorizacion, setListaEstadoAutorizacion] = useState([]);

    async function postObtenerIndicadores(usuarioId) {
     
        const values = {
            idUsuario: usuarioId,
            areaNegocioId: EnumAreaNegocio.Conservacion
        }

        const resultado = await ObtenerIndicadoresPorAN(values)
        if(resultado.status === 200) {
            setIndicadorTotal(resultado.data);
        }
    }

    async function postObtenerEstadoAutorizacion(usuarioId) {
        
        const resultado = await ObtenerEstadoAutorizacion(usuarioId);
        if (resultado.status === 200) {
            setListaEstadoAutorizacion(resultado.data);
        }

    }

    return {
        postObtenerEstadoAutorizacion,
        listaEstadoAutorizacion,
        postObtenerIndicadores,
        indicadorTotal,
    };

} 
